import React, { useEffect, useState } from "react";
import { paddingHorizontal } from "../../../utils/sizing";
import Button from "../../common/button";
import TextInput from "../../common/input";
import { uploadFile } from "../../../../../services/apiService";
import BackdropLoader from "../../../../../components/common/BackdropLoader";
import i18next from "i18next";

const EditableComponent = ({
  close,
  onUpdateContent,
  sectionContent,
  setHeading,
  setDescription,
  setImage,
  setNavBar,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const currentLanguage = i18next.language;
  const [navData, setNavItems] = useState({ content: [], id: null });

  useEffect(() => {
    if (sectionContent?.navbar.length > 0) {
      const firstNavbar = sectionContent.navbar[0];
      const translation = firstNavbar.translation.find(
        (t) => t.languageCode === currentLanguage
      );

      if (translation) {
        try {
          const parsedNavItems = JSON.parse(translation.languageText);
          setNavItems({ content: parsedNavItems, id: translation.id });
        } catch (error) {
          console.error("Error parsing navbar languageText:", error);
          setNavItems({ content: [], id: null });
        }
      }
    }
  }, [sectionContent, currentLanguage]);

  const handleImageUpload = async (event, imageSection) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsLoading(true);
    try {
      const response = await uploadFile("upload", file);
      if (!response?.url) throw new Error("Invalid response from server");

      const imageUrl = response.url;
      const updatedImageObject = {
        ...imageSection,
        translation: imageSection.translation.map((t) =>
          t.languageCode === currentLanguage
            ? { ...t, languageText: imageUrl }
            : t
        ),
      };

      setImage(updatedImageObject);
    } catch (error) {
      console.error("Image upload failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleHeadingChange = (event, heading) => {
    const newHeading = event.target.value;
    const updatedHeadingObject = {
      ...heading,
      translation: heading.translation.map((t) =>
        t.languageCode === currentLanguage
          ? { ...t, languageText: newHeading }
          : t
      ),
    };
    setHeading(updatedHeadingObject);
  };

  const handleDescriptionChange = (event, description) => {
    const newDescription = event.target.value;
    const updatedDescriptionObject = {
      ...description,
      translation: description.translation.map((t) =>
        t.languageCode === currentLanguage
          ? { ...t, languageText: newDescription }
          : t
      ),
    };

    setDescription(updatedDescriptionObject);
  };

  const handleNavbarChange = (
    event,
    navItem,
    navbarSections,
    currentTranslation
  ) => {
    const newText = event.target.value;
    const newLink =
      "#" + event.target.value.trim().toLowerCase().replace(/ /g, "");
    const updatedNavItems = navData.content.map((item) =>
      item.text === navItem.text
        ? { ...item, text: newText, link: newLink }
        : item
    );
    console.log("navbar sections------>", navbarSections);
    console.log("current trans------------>", currentTranslation);

    setNavItems({ ...navData, content: updatedNavItems });

    const updatedTranslations = navbarSections.translation.map((t) =>
      t.languageCode === currentLanguage && t.id === currentTranslation.id
        ? { ...t, languageText: JSON.stringify(updatedNavItems) }
        : t
    );

    console.log("updated translations------->", updatedTranslations);

    setNavBar({ ...navbarSections, translation: updatedTranslations });
  };

  const handleClick = (index) => {
    document.getElementById(`imageUpload-${index}`).click();
  };

  useEffect(() => {
    console.log(
      "section content inside the editable-------------->",
      sectionContent
    );
  }, [sectionContent]);

  return (
    <div className={`${paddingHorizontal}`}>
      {isLoading && <BackdropLoader />}
      <div className="w-96 flex flex-row space-x-5 mt-10 border-b pb-4">
        <Button
          value="Preview"
          onClick={() => close()}
          style={{ width: "150px", height: "50px" }}
        />
        <Button
          value="Save Changes"
          onClick={onUpdateContent}
          style={{ width: "250px", height: "50px" }}
        />
      </div>

      <div className="items-center justify-center flex flex-col mt-10">
        {sectionContent?.headings?.map((headingSection, index) => (
          <TextInput
            key={`heading-${index}`}
            placeholder={`Enter Heading ${index + 1}`}
            name="heading"
            value={
              headingSection.translation.find(
                (t) => t.languageCode === currentLanguage
              )?.languageText || ""
            }
            onChange={(event) => handleHeadingChange(event, headingSection)}
          />
        ))}
      </div>
      <div className="items-center justify-center flex flex-col mt-10">
        {sectionContent?.descriptions?.map((descriptionSection, index) => (
          <TextInput
            key={`description-${index}`}
            placeholder={`Enter Description ${index + 1}`}
            name="description"
            value={
              descriptionSection.translation.find(
                (t) => t.languageCode === currentLanguage
              )?.languageText || ""
            }
            onChange={(event) =>
              handleDescriptionChange(event, descriptionSection)
            }
          />
        ))}
      </div>

      <div className="items-center justify-center flex flex-col mt-10">
        {navData.content.map((navItem, index) => (
          <input
            key={index}
            type="text"
            placeholder={`Enter NavItem ${index + 1}`}
            className="w-full mb-5 p-2 border rounded"
            name={`navItem-${index}`}
            value={navItem.text}
            onChange={(event) =>
              handleNavbarChange(
                event,
                navItem,
                currentLanguage === "en"
                  ? sectionContent.navbar[0]
                  : sectionContent.navbar[0],
                currentLanguage === "en"
                  ? sectionContent.navbar[0].translation[0]
                  : sectionContent.navbar[0].translation[1]
              )
            }
          />
        ))}
      </div>

      <div className="grid grid-cols-2 gap-16 py-20">
        {sectionContent?.images?.map((imageSection, index) => (
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                key={index}
                onClick={() => handleClick(index)}
                className="border border-dashed p-4 text-gray-600 hover:bg-gray-50 cursor-pointer duration-300 border-gray-300 flex flex-col rounded-xl h-96 w-full items-center justify-center"
              >
                <img
                  src={
                    imageSection.translation.find(
                      (t) => t.languageCode === currentLanguage
                    )?.languageText || ""
                  }
                  alt="Selected"
                  className="h-full w-full object-contain rounded-xl"
                />
                <input
                  id={`imageUpload-${index}`}
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(event) => handleImageUpload(event, imageSection)}
                />
              </div>
              <div style={{textAlign:"center", marginTop:"4%", color:"rgb(75 85 99)", fontSize:"22px"}}>
                <span>
                  {sectionContent?.images?.length > 1 && index === 0
                    ? i18next.t("Recommended size") + ":  100 x 50"
                    : i18next.t("Recommended size") + ": 520 x 390"}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditableComponent;
